import { I18nComponente } from "@/types/gerais"

export const APaginadorDeTabelai18n: I18nComponente = {
  "pt-BR": {
    de: "de"
  },
  "es-CO": {
    de: "de"
  }
}
